export function sanitizeTranslationError(
  errorMessage: string | null | undefined,
): string | null {
  if (!errorMessage) return null;

  if (errorMessage.includes('AiUsageLimitReachedException')) {
    return "You've reached your daily AI limit. Please try again tomorrow.";
  }

  if (errorMessage.includes('401 Unauthorized')) {
    return 'Authentication error. Please try again.';
  }

  if (
    errorMessage.includes('Client error') ||
    errorMessage.includes('Server error')
  ) {
    return 'Translation service error. Please retry.';
  }

  if (errorMessage.includes('cURL error')) {
    return 'Could not connect to translation service. Please retry.';
  }

  const firstSentence = errorMessage.split(/[.!]\s/)[0];
  if (firstSentence && firstSentence.length < 200) {
    return firstSentence;
  }

  return 'Something went wrong. Please try again.';
}
